enum PaymentMeans {
  CASH = "CASH",
  CARD = "CARD",
  BANK_TRANSFER = "BANK_TRANSFER",
  DIRECT_DEBIT = "DIRECT_DEBIT",
  UNKNOWN = "UNKNOWN",
}

export default PaymentMeans;
